module.exports = __webpack_public_path__ + "static/img/banner6.eb6c97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner6.png
// module id = QuJH
// module chunks = 0